export default __webpack_public_path__ + "static/media/IBMCheckbox.7e12ed0c.svg";